import Hero from '../components/Hero'
import TestimonialsSection from '../components/Testimonials'

export default function Testimonials() {
  return (
    <>
      {/* <section className="py-16 bg-white">
        <div className="section-container">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <h2 className="section-title">What Our Clients Say</h2>
            <p className="section-subtitle">
              Trusted by businesses worldwide for reliable logistics solutions
            </p>
          </div>
        </div>
      </section> */}
      
      <TestimonialsSection />
    </>
  )
}
